import { TIERS_TYPE_FOURNISSEUR, TIERS_SOUS_TYPE_LIEU_DE_LIVRAISON } from '@/configuration/tiers/tiersConf';
import genererTiers from './genererTiers';

export default function generer(raisonSocial, societeId) {
  const lieu = genererTiers();
  lieu.nomCommercial = raisonSocial;
  lieu.type = TIERS_TYPE_FOURNISSEUR;
  lieu.sousTypes = [TIERS_SOUS_TYPE_LIEU_DE_LIVRAISON];
  lieu.societeId = societeId;
  return lieu;
}
